export const refundRequestCode = {
    "curl": {
      "request": `curl -X 'POST'
'https://demo-api.westpay.se/in-store/api/v1/refund'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-H 'Content-Type: application/json'
-d '{
    "amount": 200,
    "currencyCode": 752,
    "terminalId": "80000782",
    "transactionId": "800007822346",
    "paymentMethod": ""
}'`
    },
    "java": {
      "request": `import java.io.IOException;
import java.net.URI;
import java.net.http.HttpClient;
import java.net.http.HttpHeaders;
import java.net.http.HttpRequest;
import java.net.http.HttpResponse;
import java.net.http.HttpResponse.BodyHandlers;
import java.nio.charset.StandardCharsets;
      
import com.google.gson.Gson;
      
public class RefundExample {
    public static void main(String[] args) {
        String url = "https://demo-api.westpay.se/in-store/api/v1/refund";
        String authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        String contentType = "application/json";
        String ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
        RefundRequest requestBody = new RefundRequest(200, 752, "80000782", "800007822346", "");
      
        Gson gson = new Gson();
        String requestBodyJson = gson.toJson(requestBody);
      
        HttpClient client = HttpClient.newHttpClient();
      
        HttpRequest request = HttpRequest.newBuilder()
                .uri(URI.create(url))
                .header("accept", "text/plain")
                .header("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey)
                .header("Authorization", authorization)
                .header("Content-Type", contentType)
                .POST(HttpRequest.BodyPublishers.ofString(requestBodyJson, StandardCharsets.UTF_8))
                .build();
      
        try {
            HttpResponse<String> response = client.send(request, BodyHandlers.ofString());
            int statusCode = response.statusCode();
            HttpHeaders responseHeaders = response.headers();
            String responseBody = response.body();
      
            System.out.println("Response Code: " + statusCode);
            System.out.println("Response Headers: " + responseHeaders);
            System.out.println("Response Body: " + responseBody);
        } catch (IOException | InterruptedException e) {
            e.printStackTrace();
        }
    }
}
      
class RefundRequest {
    private int amount;
    private int currencyCode;
    private String terminalId;
    private String transactionId;
    private String paymentMethod;
      
    public RefundRequest(int amount, int currencyCode, String terminalId, String transactionId, String paymentMethod) {
        this.amount = amount;
        this.currencyCode = currencyCode;
        this.terminalId = terminalId;
        this.transactionId = transactionId;
        this.paymentMethod = paymentMethod;
    }
      
    public int getAmount() {
        return amount;
    }
      
    public void setAmount(int amount) {
        this.amount = amount;
    }
      
    public int getCurrencyCode() {
        return currencyCode;
    }
      
    public void setCurrencyCode(int currencyCode) {
        this.currencyCode = currencyCode;
    }
      
    public String getTerminalId() {
        return terminalId;
    }
      
    public void setTerminalId(String terminalId) {
        this.terminalId = terminalId;
    }
      
    public String getTransactionId() {
        return transactionId;
    }
      
    public void setTransactionId(String transactionId) {
        this.transactionId = transactionId;
    }
}`
    },
    "C#": {
      "request": `using System;
using System.Net.Http;
using System.Text;
using System.Text.Json;
using System.Threading.Tasks;
      
namespace RefundExample
{
    class Program
    {
        static async Task Main(string[] args)
        {
            string url = "https://demo-api.westpay.se/in-store/api/v1/refund";
            string authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
            string contentType = "application/json";
            string ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
            RefundRequest requestBody = new RefundRequest
            {
                Amount = 200,
                CurrencyCode = 752,
                TerminalId = "80000782",
                TransactionId = "800007822346",
                PaymentMethod = ""
            };
      
            HttpClient client = new HttpClient();
            client.DefaultRequestHeaders.Add("accept", "text/plain");
            client.DefaultRequestHeaders.Add("Authorization", authorization);
            client.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
            client.DefaultRequestHeaders.Add("Content-Type", contentType);
      
            var requestBodyJson = JsonSerializer.Serialize(requestBody);
            var requestBodyContent = new StringContent(requestBodyJson, Encoding.UTF8, "application/json");
      
            HttpResponseMessage response;
            try
            {
                response = await client.PostAsync(url, requestBodyContent);
            }
            catch (Exception e)
            {
                Console.WriteLine("An error occurred: " + e.Message);
                return;
            }
      
            var statusCode = (int)response.StatusCode;
            var responseContent = await response.Content.ReadAsStringAsync();
      
            Console.WriteLine("Response Code: " + statusCode);
            Console.WriteLine("Response Body: " + responseContent);
        }
    }
      
    class RefundRequest
    {
        public int Amount { get; set; }
        public int CurrencyCode { get; set; }
        public string TerminalId { get; set; }
        public string TransactionId { get; set; }
        public string PaymentMethod { get; set; }
    }
}`
    },
    "python": {
      "request": `import requests
import json
      
url = 'https://demo-api.westpay.se/in-store/api/v1/refund'
headers = {
    'accept': 'text/plain',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
    'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
    'Content-Type': 'application/json'
}
      
data = {
    'amount': 200,
    'currencyCode': 752,
    'terminalId': '80000782',
    'transactionId': '800007822346',
    'paymentMethod': ''
}
      
try:
    response = requests.post(url, headers=headers, json=data)
    print('Response Code:', response.status_code)
    print('Response Body:', response.text)
except requests.exceptions.RequestException as e:
    print('An error occurred:', e)`
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');

const url = 'https://demo-api.westpay.se/in-store/api/v1/refund';
const headers = {
  'accept': 'text/plain',
  'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
  'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
  'Content-Type': 'application/json'
};
      
const data = {
  amount: 200,
  currencyCode: 752,
  terminalId: '80000782',
  transactionId: '800007822346',
  paymentMethod: ''
};
      
axios.post(url, data, { headers })
  .then(response => {
    console.log('Response Code:', response.status);
    console.log('Response Body:', response.data);
  })
  .catch(error => {
    console.error('An error occurred:', error);
  });`
    }
  };
  
export const refundRequestCodeResponse = `{
    "onlineAPIRefId": "23179050000963"
}`;

  